import React from 'react'
import moment from 'moment'

const FormatDateTime = ({ timeStamp }) => (
  <div style={{ textAlign: 'center' }}>
    <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(timeStamp).format('HH:mm a')}</span>
    <br />
    {moment(timeStamp).format('DD-MMM-YYYY')}
    <br />
  </div>
)

export default FormatDateTime


// WEBPACK FOOTER //
// ./src/containers/luckyDrawWinners/components/FormatDateTime.js